// extracted by css-extract-rspack-plugin
export default {"Overlay":"select-panel-editor-module__Overlay__y0K6Yub"};